import { apiService } from './api';
import { Execution, NodeExecution } from '../types/workflow.types';
import { RecentExecution, FilterParams, PaginatedResponse } from '../types/api.types';

export const executionService = {
  getExecutions: async (params?: FilterParams): Promise<PaginatedResponse<Execution>> => {
    return await apiService.get<PaginatedResponse<Execution>>('/executions/', params);
  },

  getExecution: async (id: string): Promise<Execution> => {
    return await apiService.get<Execution>(`/executions/${id}/`);
  },

  getNodeExecutions: async (executionId: string): Promise<NodeExecution[]> => {
    const resp: any = await apiService.get<any>('/executions/node-executions/', { execution: executionId });
    return Array.isArray(resp) ? resp : (resp?.results || []);
  },

  getExecutionLogs: async (executionId: string): Promise<any[]> => {
    const resp: any = await apiService.get<any>('/executions/logs/', { execution: executionId });
    return Array.isArray(resp) ? resp : (resp?.results || []);
  },

  getRecentExecutions: async (limit: number = 10): Promise<RecentExecution[]> => {
    const executions = await apiService.get<any[]>('/executions/recent/', { limit });
    return executions.map((exec) => ({
      id: exec.id,
      workflowName: exec.workflow_name || exec.workflow?.name || 'Unknown',
      status: exec.status,
      startedAt: exec.started_at,
      duration: exec.duration ? formatDuration(exec.duration) : undefined,
    }));
  },

  getActiveExecutions: async (): Promise<Execution[]> => {
    return await apiService.get<Execution[]>('/executions/active/');
  },

  cancelExecution: async (id: string): Promise<Execution> => {
    return await apiService.post<Execution>(`/executions/${id}/cancel/`);
  },

  retryExecution: async (id: string): Promise<Execution> => {
    return await apiService.post<Execution>(`/executions/${id}/retry/`);
  },

  getExecutionStats: async (): Promise<any> => {
    return await apiService.get('/executions/stats/');
  },
};

function formatDuration(duration: string | number): string {
  if (typeof duration === 'number') {
    if (duration < 60) {
      return `${duration.toFixed(1)}s`;
    } else if (duration < 3600) {
      return `${(duration / 60).toFixed(1)}m`;
    } else {
      return `${(duration / 3600).toFixed(1)}h`;
    }
  }
  return duration.toString();
}

